module.exports = __webpack_public_path__ + "static/Grupo536-8373ad58e5c7f02f3303729c49433e81.png";